import { useTheme } from "@mui/material/styles";
import React from "react";

export default function LayoutBackground({ children }) {
  const theme = useTheme();

  return (
    <div
      style={{
        backgroundColor: theme.palette.layout.main,
        minHeight: "100vh",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
}
